import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Lock from "rialto-icons/Lock";
import PlusCircle from "rialto-icons/PlusCircle";

import Checkbox from "components/Checkbox";
import CompanyTooltip from "components/CompanyTooltip";
import IconButton from "components/IconButton";
import Tooltip from "components/Tooltip";
import Translate from "utils/translate";

import styles from "./CompanyBlock.css";

const { t } = new Translate("CompanyBlock");

const CompanyBlock = ({
  children,
  company,
  isEditable,
  isFake,
  isSelected,
  logoUrl,
  onCreatePortfolio,
  onSelectCompany,
}) => (
  <div className={cx(styles.root, { [styles.fake]: isFake })}>
    <div className={styles.header}>
      <div onClick={isFake ? null : onSelectCompany}>
        <div className={styles.radio}>
          {isFake ? <Lock /> : <Checkbox isChecked={isSelected} />}
        </div>
        <div className={styles.logo}>
          <div className={styles.fill} style={{ backgroundImage: `url('${logoUrl}')` }} />
        </div>
        <div className={styles.companyName}>
          <CompanyTooltip assets={[]} company={company} />
        </div>
      </div>
      {isEditable && (
        <div className={cx(styles.tooltip)}>
          <Tooltip place="left" tip={<IconButton icon={PlusCircle} onClick={onCreatePortfolio} />}>
            {t("newPortfolio")}
          </Tooltip>
        </div>
      )}
    </div>
    {children}
  </div>
);

CompanyBlock.propTypes = {
  children: PropTypes.node,
  logoUrl: PropTypes.string,
  onCreatePortfolio: PropTypes.func.isRequired,
  onSelectCompany: PropTypes.func.isRequired,
  isEditable: PropTypes.bool,
  isFake: PropTypes.bool,
  isSelected: PropTypes.bool,
  company: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
};

export default CompanyBlock;
